function ExperienceItem({ index, position, dateRange, company, location, description, logoUrl }) {
  return (
    <article
      className="glass-panel relative overflow-hidden px-4 py-5 sm:px-6"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-emerald-200/65 via-emerald-400/50 to-emerald-700/35" />

      <div className="flex flex-col gap-5 md:flex-row md:gap-8">
        <div className="md:w-1/3">
          <p className="text-xs font-bold uppercase tracking-[0.12em] text-emerald-300/90">{dateRange}</p>
          <h3 className="mt-2 text-xl font-semibold text-emerald-50">{position}</h3>
        </div>

        <div className="hidden w-px bg-emerald-300/20 md:block" />

        <div className="md:w-2/3">
          <div className="flex items-start gap-4">
            <div className="h-14 w-14 shrink-0 rounded-2xl border border-emerald-200/20 bg-emerald-800/45 p-2">
              <img src={logoUrl} alt={`${company} logo`} className="h-full w-full rounded-xl object-contain" />
            </div>

            <div>
              <h4 className="text-2xl font-bold text-emerald-100">{company}</h4>
              {location && (
                <p className="mt-1 text-xs font-semibold uppercase tracking-[0.08em] text-emerald-300/90">
                  {location}
                </p>
              )}
              <p className="mt-2 text-sm leading-relaxed text-emerald-100 sm:text-base">{description}</p>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default ExperienceItem; 